import React, { useContext, useEffect, useCallback } from "react";
import AifPmsOrders from "@frameworks/pmsjourney/app/OrderBookApp";
import { ProductOrderContext } from "@frameworks/salesjourney/components/Features/ActivityBook/RM_Orderbook/ProductOrders/ProductOrdersContext";
import OrderBookAlert from "../components/OrderbookAlert/OrderBookAlert";
var OrderbookAlertComponent = function () { return React.createElement(OrderBookAlert, null); };
var ProductOrderBook = function (_a) {
    var subCategoryId = _a.subCategoryId;
    var setProductOrdersNotificationComponent = useContext(ProductOrderContext).setProductOrdersNotificationComponent;
    var memoizedAlertComponent = useCallback(function () { return React.createElement(OrderbookAlertComponent, null); }, []);
    useEffect(function () {
        setProductOrdersNotificationComponent(memoizedAlertComponent);
    }, [setProductOrdersNotificationComponent, memoizedAlertComponent]);
    return React.createElement(AifPmsOrders, { subCategoryId: subCategoryId });
};
export default ProductOrderBook;
